import { render, staticRenderFns } from "./VueOdometer.vue?vue&type=template&id=d78dfece"
import script from "./VueOdometer.vue?vue&type=script&lang=js"
export * from "./VueOdometer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports